import { EdgeBNPLCapabilities } from 'hooks/payment/bnplCapabilities/useBnplCapabilities';

const bnplCapabilitiesMap: Record<
  EdgeBNPLCapabilities,
  'affirm' | 'afterpay_clearpay' | 'klarna'
> = {
  [EdgeBNPLCapabilities.AFFIRM]: 'affirm',
  [EdgeBNPLCapabilities.AFTERPAY]: 'afterpay_clearpay',
  [EdgeBNPLCapabilities.KLARNA]: 'klarna',
};

export const getStripePaymentMethodTypes = (
  bnplCapabilities?: EdgeBNPLCapabilities[],
) => {
  return bnplCapabilities?.map((capability) => {
    return bnplCapabilitiesMap[capability];
  });
};
